export enum PasswordStrength {
  "Weak" = "Słabe",
  "Medium" = "Średnie",
  "Strong" = "Silne",
}
